import * as Sentry from '@sentry/react'
import {
  AnalyticsEventFromNamespace,
  AnalyticsNamespace,
} from '~/types/Analytics'
import { capturePosthogEvent } from '~/utils/initializePosthog'

import {
  ExtensionInstance,
  Analytics as IAnalytics,
  Pbx,
  SessionUser,
} from '@mangovoice/types'

export const initializeAnalytics = (
  user: SessionUser | undefined,
  userExtension: ExtensionInstance | undefined,
  pbx: Pbx | undefined,
) => {
  if (user && user.id !== undefined && userExtension) {
    Sentry.setUser({
      id: user.id.toString(),
      username: userExtension.name,
    })
  }

  if (pbx) {
    Sentry.setContext('pbx', {
      pbx_id: pbx.id,
      pbx_uuid: pbx.uuid,
      pbx_name: pbx.name,
    })
  }
}

export class Analytics<
  TNamespace extends AnalyticsNamespace,
> implements IAnalytics {
  private _nameSpace: TNamespace
  constructor(nameSpace: TNamespace) {
    this._nameSpace = nameSpace
  }

  public track(
    name: AnalyticsEventFromNamespace<TNamespace>,
    data?: Record<string, unknown>,
  ) {
    const eventName = `${this._nameSpace}_${name}`
    // track() runs inside API and auth flows (e.g. postMessage, getRefreshToken),
    // so a failing sink must not fail the operation.
    try {
      capturePosthogEvent(eventName, data)
    } catch {
      // Fire-and-forget; analytics errors must not affect the app.
    }
  }
}
